import React from "react";
import "../../components/PetMicrochipQuantityList/PetMicrochipQuantityList.css";
import CheckIcon from "@mui/icons-material/Check";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SearchIcon from '@mui/icons-material/Search';


const PetMicrochipQuantityList = ({userDetailResponse, setOpenProfile, openProfile}) => {
    //console.log(userDetailResponse);
  return (
    <div className="container-fluid">
      
      <div className="petMicrochipQuantityList">
        <table>
          <tr className="petMicrochipQuantityListHeading">
            <th>S no.</th>
            <th>Product Name</th>
            <th>Inventory Count</th>
            <th>City</th>
            <th>Quantity</th>
            
            <th>Status</th>
            <th>Details</th>
            <th>Search</th>
            
          </tr>

          <tr>
   <td rowSpan={3}>01</td>
   <td rowSpan={3}>Dog Microchip</td>
   <td rowSpan={3}>20</td>
   <td>Gurugram</td> 
   <td>15</td>
   <td>
                <button className="Statusbutton">
                    <CheckIcon className="icon" />
                    Active
                </button>
            </td>
            <td>
            <button style={{ height: "35px", width: "35px", backgroundColor: "#F1F1F1"}} onClick={() => setOpenProfile(!openProfile)}>
                    <EditOutlinedIcon className="icon" />
                </button>
                <button style={{ height: "35px", width: "35px", marginLeft: "5px", backgroundColor: "#F4616F", borderColor: "#FF0000"}} >
                    <DeleteOutlinedIcon className="icon" />
                </button>
            </td>
            <td>
              <SearchIcon />
            </td>
  </tr>
  <tr>
  <td>Mumbai</td>
  <td>15</td>
  <td>
                <button className="Statusbutton">
                    <CheckIcon className="icon" />
                    Active
                </button>
            </td>
            <td>
            <button style={{ height: "35px", width: "35px", backgroundColor: "#F1F1F1"}} onClick={() => setOpenProfile(!openProfile)}>
                    <EditOutlinedIcon className="icon" />
                </button>
                <button style={{ height: "35px", width: "35px", marginLeft: "5px", backgroundColor: "#F4616F", borderColor: "#FF0000"}} >
                    <DeleteOutlinedIcon className="icon" />
                </button>
            </td>
            <td>
              <SearchIcon />
            </td>
  </tr>
  <tr>
    <td>Bengaluru</td>
    <td>15</td>
    <td>
                <button className="Statusbutton">
                    <CheckIcon className="icon" />
                    Active
                </button>
            </td>
            <td>
            <button style={{ height: "35px", width: "35px", backgroundColor: "#F1F1F1"}} onClick={() => setOpenProfile(!openProfile)}>
                    <EditOutlinedIcon className="icon" />
                </button>
                <button style={{ height: "35px", width: "35px", marginLeft: "5px", backgroundColor: "#F4616F", borderColor: "#FF0000"}} >
                    <DeleteOutlinedIcon className="icon" />
                </button>
            </td>
            <td>
              <SearchIcon />
            </td>
  </tr>

          {/* {userDetailResponse !== null ? (
    userDetailResponse.map((user) => (
        <tr key={user.id}>
            <td>1</td>
            <td>{user.name}</td>
            <td>{user.designation}</td>
            <td>kumud@gmail.com</td>
           
            <td>
                <button className="Statusbutton">
                    <CheckIcon className="icon" />
                    Active
                </button>
            </td>
            <td>
            <button style={{ height: "35px", width: "35px", backgroundColor: "#F1F1F1"}} onClick={() => setOpenProfile(!openProfile)}>
                    <EditOutlinedIcon className="icon" />
                </button>
                <button style={{ height: "35px", width: "35px", marginLeft: "5px", backgroundColor: "#F4616F", borderColor: "#FF0000"}} >
                    <DeleteOutlinedIcon className="icon" />
                </button>
            </td>
        </tr>
    ))
) : (
    <p>empty</p>
)} */}
         
          
        </table>
      </div>
    </div>
  );
};

export default PetMicrochipQuantityList;
